export default __webpack_public_path__ + "static/media/CreditNoteReport.c435b889.svg";